import styled, { css } from "styled-components"
import { skippedOpacity } from "./ExecutionOverlay.styled"

import { BRANCH_CASE_SLOT_W, NODE_W } from "../constants"

const minWidth = (caseCount: number) =>
  Math.max(NODE_W, BRANCH_CASE_SLOT_W * (caseCount + 1) + 80)

export const NodeContainer = styled.div<{
  $skipped?: boolean
  $caseCount: number
}>`
  position: relative;
  background: ${(p) => p.theme.colors.white};
  border: 0.1rem solid ${(p) => p.theme.colors.workflows.branch};
  border-radius: 0.8rem;
  width: ${(p) => minWidth(p.$caseCount) / 10}rem;
  box-shadow: 0 0.2rem 0.4rem rgba(0, 0, 0, 0.1);
  ${skippedOpacity}
`

export const NodeHeader = styled.div`
  background: ${(p) => p.theme.colors.workflows.branch};
  color: ${(p) => p.theme.colors.white};
  padding: 0.6rem 1.2rem;
  border-radius: 0.8rem 0.8rem 0 0;
  margin: -0.1rem -0.1rem 0 -0.1rem;
  font-size: 1rem;
  text-transform: uppercase;
  letter-spacing: 0.05rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  ${(p) => p.theme.bold};
`

export const NodeBody = styled.div`
  padding: 1rem 1.2rem;
  font-size: 1.3rem;
  ${(p) => p.theme.bold};
`

export const CaseSummary = styled.div`
  padding: 0 1.2rem 0.8rem;
  font-size: 1.1rem;
  color: ${(p) => p.theme.colors.greyDarker};
`

const pillBase = css`
  position: absolute;
  bottom: -2.6rem;
  transform: translateX(-50%);
  pointer-events: none;
  padding: 0.25rem 0.9rem;
  border-radius: 1rem;
  font-size: 0.95rem;
  line-height: 1;
  text-transform: uppercase;
  letter-spacing: 0.04rem;
  color: #fff;
  box-shadow: 0 0.1rem 0.25rem rgba(0, 0, 0, 0.12);
  white-space: nowrap;
  max-width: ${BRANCH_CASE_SLOT_W / 10}rem;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const CasePill = styled.div`
  ${pillBase}
  background: ${(p) => p.theme.colors.workflows.branch};
  ${(p) => p.theme.bold};
`

export const OtherwisePill = styled.div`
  ${pillBase}
  background: #6b7280;
  ${(p) => p.theme.bold};
`

/** Tiny inline "+" button on the BRANCH header that appends an empty case.
 *  The "+" glyph is rendered via ::before so we can compensate for its
 *  slightly-low optical centre in most fonts. */
export const InlineAddCaseButton = styled.button`
  pointer-events: all;
  appearance: none;
  border: none;
  background: rgba(255, 255, 255, 0.18);
  color: #fff;
  width: 1.8rem;
  height: 1.8rem;
  border-radius: 50%;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  font-size: 0;
  line-height: 0;
  transition: background 0.15s ease;

  &::before {
    content: "+";
    font-size: 1.4rem;
    line-height: 1;
    display: inline-block;
    transform: translate(0, -0.05rem) translateZ(0);
  }

  &:hover {
    background: rgba(255, 255, 255, 0.35);
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`
